import React, { useEffect, useState } from "react";
import styles from "./ReportStaffs.module.css";

// Components
import NavDashboard from "../../components/NavDashboard";
import { convertRole, covertTimeZone, NewCovertTimeZone, numberFormat, splitDateTime } from "../../helper";
import CurrentDateComponents from "../../components/CurrentDateComponents";
// import { LINEAR_GRADIENT_BG } from "../../const";
import OrderStaffLists from "./ReportLists/OrderStaffLists";
import { GET_REPORT_ORDERS_STAFF, GET_REPORT_ORDERS_STAFF_V2 } from "../../apollo/dashboard/query";
// import AnimationLoading from "../../components/Animationloading";

// Apollo Client
import { useLazyQuery } from "@apollo/client";

// React Bootstrap
import { Card, Button, Row, Col, Form, Placeholder, Badge, InputGroup } from "react-bootstrap";
import _ from "lodash";
import PaginationHelper from "../../components/PaginationHelper";
import { GET_STAFF_INFO } from "../../apollo/user/query";
import moment from "moment";
import { GET_CATEGORYS } from "../../apollo/category/query";
import { FaSearch } from "react-icons/fa";
import { MdDateRange } from "react-icons/md";

export default function ReportStaffs() {
    // States
    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    const [reportDatas, setReportDatas] = useState({
        total: 0,
        datas: [],
        report: {}
    });
    // default this month
    let defaultStartMonth = moment().startOf("month").format("YYYY-MM-DD");
    let defaultEndMonth = moment().endOf("month").format("YYYY-MM-DD");
    const [staffInfos, setStaffInfos] = useState([]);
    const [isCurrentModals, setIsCurrentModals] = useState(false);
    const [cdFillter, setCdFillter] = useState({
        createdAt_gte: defaultStartMonth ?? "",
        createdAt_lt: defaultEndMonth ?? "",
    });
    const [userAuthData, setUserAuthData] = useState("");
    const [workTimePeriod, setWorkTimePeriod] = useState();
    const [status, setStatus] = useState("COMPLETED");
    const [workStartTime, setWorkStartTime] = useState()
    const [workEndTime, setWorkEndTime] = useState()
    const [viewUser, setViewUser] = useState();
    const [categories, setCategories] = useState([])
    const [categoriesPrepare, setCategoriesPrepare] = useState(null)
    const [invioceNo, setInvioceNo] = useState()
    const [activeButton, setActiveButton] = useState("thisMonth");
    const [payment, setPayment] = useState("");
    const [distinguish, setDistinguish] = useState(false);
    const { _limit, _skip, Pagination_helper } = PaginationHelper();

    // GraphQL query
    // const [getOrderAndReportStaff, { data: orderAndReportStaff, loading: loadingOrderReport }] = useLazyQuery(GET_REPORT_ORDERS_STAFF, {
    //     fetchPolicy: "cache-and-network",
    // });
    const [getOrderAndReportStaffV2, { data: orderAndReportStaffV2, loading: loadingOrderReportV2 }] = useLazyQuery(GET_REPORT_ORDERS_STAFF_V2, {
        fetchPolicy: "cache-and-network",
    });
    const [loadUsers, { data: userDatas, loading: loadingUsers }] = useLazyQuery(GET_STAFF_INFO, {
        fetchPolicy: "cache-and-network",
    });
    const [loadCategoryData, { data: categoryData, loading: loadingLoadCategory }] = useLazyQuery(
        GET_CATEGORYS,
        { fetchPolicy: "cache-and-network" }
    );

    // useEffect to handle data updates
    useEffect(() => {
        if (orderAndReportStaffV2 && orderAndReportStaffV2?.ReportStaffsV2?.status) {
            const newData = JSON.parse(orderAndReportStaffV2?.ReportStaffsV2?.msg);
            setReportDatas({
                total: orderAndReportStaffV2?.ReportStaffsV2?.total ?? 0,
                datas: newData,
                report: orderAndReportStaffV2?.ReportStaffsV2?.reports ?? {}
            });
        }
    }, [orderAndReportStaffV2]);

    useEffect(() => {
        if (categoryData) {
            setCategories(categoryData?.categories?.data);
        }
    }, [categoryData]);

    useEffect(() => {
        if (userDatas) {
            setStaffInfos(userDatas?.users?.data)
        }
    }, [userDatas]);

    useEffect(() => {
        fetchDataReport();

    }, [shopId, cdFillter, _skip, userAuthData, categoriesPrepare, distinguish, 
        workStartTime, workEndTime, categoriesPrepare, invioceNo, payment, status
    ]);


    useEffect(() => {
        fetchUserDatas();
        factCategorys()
    }, [shopId]);

    // get category data
    const factCategorys = async () => {
        let localData = JSON.parse(localStorage.getItem("SHOP_DATA"))
        if (loadingLoadCategory) return
        try {

            await loadCategoryData({
                variables: {
                    limit: null,
                    where: {
                        isDeleted: false,
                        orderBy: "createdAt_DESC",
                        shop: localData?.id,
                    },
                },
            });

        } catch (error) {
            console.log({ error })
        }
    }

    // get user or staff data
    const fetchUserDatas = async () => {
        try {

            if (loadingUsers) return;
            await loadUsers({
                variables: {
                    where: {
                        shop: shopId
                    },
                },
            });

        } catch (error) {
            console.log({ error })

        }
    }

    // get report data from ordergroup
    const fetchDataReport = async () => {
        try {
            if (loadingOrderReportV2) return;

            let _where = {
                shop: shopId,
                type: "POS",
                isDeleted: false,
                distinguish: distinguish,
                // createBy: viewUser.id,
            };
            if (cdFillter?.createdAt_gte && cdFillter?.createdAt_lt) {
                _where = {
                    ..._where,
                    createdAt_gte: NewCovertTimeZone(cdFillter?.createdAt_gte),
                    createdAt_lt: NewCovertTimeZone(cdFillter?.createdAt_lt),
                };
            }
            if (userAuthData !== "" && !_.isEmpty(staffInfos)) {
                const newUserView = staffInfos.find((data) => data?.id === userAuthData);
                if (newUserView) {
                    setViewUser(newUserView);
                    _where = {
                        ..._where,
                        createBy: newUserView?.id
                    }
                }
            }
            if (!_.isEmpty(invioceNo) || invioceNo !== "") {
                _where = {
                    ..._where,
                    code: invioceNo
                }
            }

            if (workStartTime && workEndTime) {
                _where = {
                    ..._where,
                    startTime: workStartTime,
                    endTime: workEndTime
                }
            }
            if (!_.isEmpty(categoriesPrepare)) {
                _where = {
                    ..._where,
                    category: categoriesPrepare?.id,
                    categoryName: categoriesPrepare?.name
                }
            }
            if (payment !== "") {
                _where = {
                    ..._where,
                    payment: payment
                }
            }
            if (status !== "") {
                _where = {
                    ..._where,
                    status: status
                }
            }
            await getOrderAndReportStaffV2({
                variables: {
                    where: _where,
                    skip: (_skip - 1) * _limit,
                    limit: _limit,
                },
            });
        } catch (error) {
            console.error(error);
        }
    };

    // handle change category
    const handleChangeCategory = (values) => {
        let _categoriesData = categories?.filter((category) => values?.includes(category?.id))
        setCategoriesPrepare(_categoriesData[0])
    }

    // on change invoice no
    const onChangeInvoiceNo = (e) => {
        const { value } = e.target;
        setInvioceNo(value);
        if (value === "") {
            setInvioceNo("");
        }
    };


    // prepare ordergrup and loading
    const initailDatas = {
        orderGroups: reportDatas?.datas,
        loadingOrderReportV2,
        orderAndReportStaffV2,
        _limit, _skip
    }

    return (
        <NavDashboard title="ຕົ້ນທຶນ" mainHeight="auto" mainBg="#ffffff">
            <Card className={styles.filterCard}>
                <Row className={styles.filterRow + " pt-2"}>
                    <Col md="auto">
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label className={styles.filterLabel}><FaSearch />ເລກທີ່ບິນ</Form.Label>
                            <InputGroup className="mb-3">
                                <Form.Control
                                    placeholder="Search..."
                                    aria-label="invoice_no"
                                    aria-describedby="basic-addon1"
                                    value={invioceNo}
                                    onChange={(e) => onChangeInvoiceNo(e)}
                                    style={{ minWidth: 120 }}
                                />
                            </InputGroup>
                        </Form.Group>
                    </Col>
                    <Col md="auto">
                        <Form.Group>
                            <Form.Label className={styles.filterLabel}>ກະເຮັດວຽກ</Form.Label>
                            <Form.Select value={workTimePeriod} onChange={(e) => {
                                let newValue = e?.target?.value;
                                setWorkTimePeriod(newValue);
                                if (newValue == "MORNING") {
                                    setWorkStartTime("08:00")
                                    setWorkEndTime("16:00")
                                } else if (newValue == "AFTERNOON") {
                                    setWorkStartTime("16:00")
                                    setWorkEndTime("00:00")
                                }
                                else if (newValue == "EVENING") {
                                    setWorkStartTime("00:00")
                                    setWorkEndTime("08:00")
                                }
                            }} aria-label="Default select example" style={{ width: 180, height: 40 }}>
                                <option value="">--ເລືອກ--</option>
                                <option value="MORNING">ກະເຊົ້າ</option>
                                <option value="AFTERNOON">ກະແລງ</option>
                                <option value="EVENING">ກະຄ່ຳ</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {/* Status */}
                    <Col md="auto">
                        <Form.Group>
                            <Form.Label className={styles.filterLabel}>ສະຖານະ</Form.Label>
                            <Form.Select value={status} onChange={(e) => {
                                setStatus(e?.target?.value);
                            }} aria-label="Default select example" style={{ width: 180, height: 40 }}>
                                <option value="">--ເລືອກ--</option>
                                <option value="COMPLETED">ຊຳລະແລ້ວ</option>
                                <option value="INDEBTED">ຕີດຫນີ້</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {/* Staff */}
                    <Col md="auto">
                        <Form.Group>
                            <Form.Label className={styles.filterLabel}>ພະນັກງານ</Form.Label>
                            <Form.Select value={viewUser?.id} onChange={(e) => setUserAuthData(e?.target?.value)} aria-label="Default select example" style={{ width: 180, height: 40 }}>
                                <option value="">--ເລືອກ--</option>
                                {
                                    staffInfos.length > 0 && staffInfos.map((user, _key) => (
                                        <option key={_key} value={user?.id}>{user?.firstName} {user?.lastName}</option>
                                    ))
                                }
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md="auto">
                        <Form.Group>
                            <Form.Label className={styles.filterLabel}>ປະເພດສິນຄ້າ</Form.Label>
                            <Form.Select onChange={(e) => handleChangeCategory(e?.target?.value)} aria-label="Default select example">
                                <option value="">--ເລືອກ--</option>
                                {categoryData && categories.map((option, _index) => (
                                    <option key={_index} value={option?.id}>{option?.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md="auto">
                        <Form.Group>
                            <Form.Label className={styles.filterLabel}>ຊຳລະເງິນ</Form.Label>
                            <Form.Select onChange={(e) => setPayment(e?.target?.value)} aria-label="Select payment">
                                <option value="">--ເລືອກ--</option>
                                <option value="CASH">ເງິນໂອນ</option>
                                <option value="TRANSFER">ເງິນສົດ</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md="auto">
                        <Form.Group className="mb-3 d-flex flex-column" controlId="exampleForm.ControlInput1">
                            <Form.Label className={styles.filterLabel}><MdDateRange />ວັນທີ, ເດືອນ, ປີ</Form.Label>
                            <Button
                                variant="outline-secondary"
                                onClick={() => setIsCurrentModals(true)}
                                style={{ width: "100%", maxWidth: 260, display: "flex", justifyContent: "start", gap: 5 }}
                            >
                                <MdDateRange style={{ fontSize: 20 }} />
                                {!cdFillter.createdAt_gte || !cdFillter.createdAt_lt ? (
                                    "mm/dd/yyyy"
                                ) : (
                                    <>
                                        {covertTimeZone(cdFillter.createdAt_gte) +
                                            "-" +
                                            covertTimeZone(cdFillter.createdAt_lt)}
                                    </>
                                )}
                            </Button>
                        </Form.Group>
                    </Col>
                    <Col md="auto">
                        <Form.Check
                            type="checkbox"
                            id="distinguish-id"
                            label={
                                <span style={{ fontSize: 14, color: distinguish ? 'red' : 'black' }}>
                                    {distinguish ? 'ຈຳແນະອໍເດີຍ່ອຍ' : 'ບໍ່ຈຳແນະອໍເດີຍ່ອຍ'}
                                </span>
                            }
                            onChange={(e) => setDistinguish(e.target.checked)}
                            checked={distinguish}
                        />
                    </Col>
                    {/* <Col md="auto" className="d-flex align-items-end">
                        <Button variant="primary" style={{ minWidth: 100 }} onClick={() => fetchDataReport()}>
                            <FaSearch style={{ marginRight: 6 }} />ຄົ້ນຫາ
                        </Button>
                        <Button variant="outline-secondary" className={styles.clearBtn} onClick={() => {
                            setInvioceNo("");
                            setWorkTimePeriod("");
                            setWorkStartTime("");
                            setWorkEndTime("");
                            setUserAuthData("");
                            setViewUser(undefined);
                            setCategoriesPrepare(null);
                            setPayment("");
                            setCdFillter({
                                createdAt_gte: defaultStartMonth,
                                createdAt_lt: defaultEndMonth
                            });
                            setActiveButton("thisMonth");
                            setDistinguish(false);
                        }}>
                            ລ້າງຄົ້ນຫາ
                        </Button>
                    </Col> */}
                </Row>
            </Card>

            {loadingOrderReportV2 && !orderAndReportStaffV2 ? (
                <Row>
                    <Col md={8}>
                        <Placeholder as="p" animation="wave">
                            <Placeholder bg="light" style={{ height: 240, width: '100%' }} />
                        </Placeholder>
                    </Col>
                    <Col md={4}>
                        <Placeholder as="p" animation="wave">
                            <Placeholder bg="light" style={{ height: 240, width: '100%' }} />
                        </Placeholder>
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col md={8} className="mb-4">
                        <Card className={styles.staffCard}>
                            <Card.Header className="border-0 pb-0">
                                <div className={styles.sectionTitle}>
                                    <div className={styles.staffAvatar}>
                                        {viewUser?.firstName ? viewUser.firstName.charAt(0).toUpperCase() : "?"}
                                    </div>
                                    {viewUser?.firstName ?? "ບໍ່ມີຂໍ້ມູນ"} {viewUser?.lastName ?? ""}
                                </div>
                            </Card.Header>
                            <Card.Body className="pt-2">
                                <Row className="g-3">
                                    <Col sm={6}>
                                        <div className="d-flex align-items-center gap-2">
                                            <small className="text-muted">ເພດ:</small>
                                            <span>{viewUser?.gender ?? "-"}</span>
                                        </div>
                                    </Col>
                                    <Col sm={6}>
                                        <div className="d-flex align-items-center gap-2">
                                            <small className="text-muted">ເບີໂທ:</small>
                                            <span>{viewUser?.phone ?? "-"}</span>
                                        </div>
                                    </Col>
                                    <Col sm={6}>
                                        <div className="d-flex align-items-center gap-2">
                                            <small className="text-muted">ອີເມວ:</small>
                                            <span>{viewUser?.email ?? "-"}</span>
                                        </div>
                                    </Col>
                                    <Col sm={6}>
                                        <div className="d-flex align-items-center gap-2">
                                            <small className="text-muted">ສິດນຳໃຊ້:</small>
                                            {viewUser?.role && (
                                                <Badge pill bg={viewUser?.role === "ADMIN" ? "danger" : "secondary"} className="px-2 py-1">
                                                    {convertRole(viewUser?.role)}
                                                </Badge>
                                            )}
                                        </div>
                                    </Col>
                                    <Col xs={12}>
                                        <div className="d-flex align-items-center gap-2">
                                            <small className="text-muted">ທີ່ຢູ່:</small>
                                            <span>{[viewUser?.address?.village, viewUser?.address?.district, viewUser?.address?.province].filter(Boolean).join(", ") || "-"}</span>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4">
                        <Card className={styles.reportCard}>
                            <Card.Header className="border-0 pb-0">
                                <div className={styles.sectionTitle}>ລວມຍອດຂາຍທັງໝົດ</div>
                            </Card.Header>
                            <Card.Body className="pt-2">
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ທັງໝົດ ເງີນ/ອໍເດີ້</span>
                                    <span className={styles.balanceValue}>
                                        ₭{numberFormat(reportDatas?.report?.balanceSumPrice ?? 0)} / {reportDatas?.total ?? 0}
                                    </span>
                                </div>
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ເງິນກີບ</span>
                                    <span className={styles.balanceValue} style={{ color: reportDatas?.report?.balanceKip < 1 ? "#dc3545" : "#198754" }}>
                                        ₭{numberFormat(reportDatas?.report?.balanceKip ?? 0)}
                                    </span>
                                </div>
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ເງິນບາດ</span>
                                    <span className={styles.balanceValue} style={{ color: reportDatas?.report?.balanceBaht < 1 ? "#dc3545" : "#198754" }}>
                                        ฿{numberFormat(reportDatas?.report?.balanceBaht ?? 0)}
                                    </span>
                                </div>
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ເງິນໂດລາ</span>
                                    <span className={styles.balanceValue} style={{ color: reportDatas?.report?.balanceUsd < 1 ? "#dc3545" : "#198754" }}>
                                        ${numberFormat(reportDatas?.report?.balanceUsd ?? 0)}
                                    </span>
                                </div>
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ເງິນໂອນ</span>
                                    <span className={styles.balanceValue} style={{ color: reportDatas?.report?.totalTransfer < 1 ? "#dc3545" : "#198754" }}>
                                        ₭{numberFormat(reportDatas?.report?.totalTransfer ?? 0)}
                                    </span>
                                </div>
                                <div className={styles.balanceRow}>
                                    <span className={styles.balanceLabel}>ເງິນສົດ</span>
                                    <span className={styles.balanceValue} style={{ color: reportDatas?.report?.totalCash < 1 ? "#dc3545" : "#198754" }}>
                                        ₭{numberFormat(reportDatas?.report?.totalCash ?? 0)}
                                    </span>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
            )}

            <OrderStaffLists initailDatas={initailDatas} distinguish={distinguish} />
            {(loadingOrderReportV2 && !orderAndReportStaffV2) ? "" :
                <div style={{ display: "flex", justifyContent: 'end' }}>
                    {Pagination_helper(reportDatas?.total, "", ``)}
                </div>
            }

            <CurrentDateComponents
                onCloseModal={() => setIsCurrentModals(false)}
                openModal={isCurrentModals}
                setCdFillter={setCdFillter}
                setActiveButton={setActiveButton}
                activeButton={activeButton}
            />
        </NavDashboard>
    );
}
